import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

export default function buildResponseAdapterOptions() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var additionalFacetValueFields = Object.entries(config.facets || {}).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        fieldName = _ref2[0],
        facetConfig = _ref2[1];

    if (facetConfig.unit && facetConfig.center) {
      return _objectSpread(_objectSpread({}, acc || {}), {}, _defineProperty({}, fieldName, _objectSpread(_objectSpread({}, facetConfig.unit && {
        unit: facetConfig.unit
      }), facetConfig.center && {
        center: facetConfig.center
      })));
    }

    return acc;
  }, null);
  return _objectSpread({}, additionalFacetValueFields && {
    additionalFacetValueFields: additionalFacetValueFields
  });
}